var cart = {
    'getCount': function (forceReload) {
        cyclone3.log('[product.cart.getCount]');
        
        var uri = cyclone3.domain + '/xml/' + cyclone3.lng + '/' + cyclone3.legal + '/cart_action.xml';

        $.ajax(
        {
            type: "GET",
            url: uri,
            dataType: 'xml',
            success: function(data) {
                try
                {
                    c3site.product.cart.updateCount(data);
                }catch(e) {
                    cyclone3.log('error ' + e);
                }
            }
        });
    },
    'updateCount': function (data) {
        cyclone3.log('[product.cart.updateCount]');
        var count = parseInt(data.items);
        if(!count) {
            count = 0;
        }
        
        if (count > 0) {
            $(".cart-count").removeClass("d-none").text(count);
        } else {
            $(".cart-count").addClass("d-none").text();
        }
    },
    'updateCartMini': function (event) {
        
        console.log("updatae card mini");
        if ($(".cart-dropdown").length) {
            $.ajax({
                type: "GET",
                url: cyclone3.domain + '/' + cyclone3.lng + '/service/cart_chunk',
                success: function(data)
                {
                    try {                    
                        if (data) {
                            var dropdown = $(data).find('.dropdown-menu');
                            $(".cart-dropdown").find('.dropdown-menu').remove();
                            $(".cart-dropdown").append(dropdown);
                            if (event){
                                //console.log(event.type);
                            } else{
                                $(".product-action .in-cart__info").removeClass('d-none').hide().fadeIn();
                            };
                        }
                        
                    } catch(e) {
                        alert(e);
                    }                    
                }
            });  
        }   
    },
    'set': function(elem, ID, amount, mj, koef, callback) {
        if (!amount) {
            amount = 1;
        }
        
        $.ajax(
        {
            type: "GET",
            url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/cart_action?action=set&ID=' + ID + '&amount=' + amount + '&mj=' + mj + '&koef=' + koef,
            dataType: 'json',
            success: function(data) {
                try{
                    console.log(callback);
                    if (callback == "reloadPage") {
                        location.reload();
                    }
                }catch(e) {
                    cyclone3.log('error ' + e);
                }
            }
        });
    },
    'remove': function(elem, ID, mj, callback) {
        $.ajax(
        {
            type: "GET",
            url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/cart_action?action=del&ID=' + ID + '&mj=' + mj,
            dataType: 'json',
            success: function(data) {
                try{
                    if (callback == "reloadPage") {
                        location.reload();
                    }
                }catch(e) {
                    cyclone3.log('error ' + e);
                }
            }
        });
    },
    'add': function(elem, ID, amount, mj, koef) {
        if(!amount) {
            amount = 1;
        }
        
        $.ajax(
        {
            type: 'GET',
            url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/cart/action?action=add&ID=' + ID + '&amount=' + amount + '&mj=' + mj + '&koef=' + koef,
            dataType: 'json',
            success: function(data) {
                try{
                    cart.updateCount(data);	
                    cart.updateCartMini();	
                }catch(e) {
                    cyclone3.log('error ' + e);
                }
            }
        });
    },
    'coupon_add': function(coupon) {
       
        $.ajax(
        {
            type: 'GET',
            url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/cart/action?action=coupon&coupon=' + coupon,
            dataType: 'json',
            success: function(data) {
                location.reload();
            }
        });
    },
    'coupon_remove': function() {
       
        $.ajax(
        {
            type: 'GET',
            url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + cyclone3.legal + '/cart/action?action=coupon',
            dataType: 'json',
            success: function(data) {              
                location.reload();
            }
        });
    }
};

(function ($) {
    
    // ADD TO CART
    $(document).on("click", '.formAddToCart button.addToCart', function(e) {        
        e.preventDefault();
        var btn = $(this);
        var form = btn.closest("form");
        var ID = form.find('[name="addToCartProductID"]').val();
        var amount = form.find('[name="addToCartAmount"]').val();
        var mj = form.find('[name="addToCartMj"]').val();
        var koef = form.find('[name="addToCartKoef"]').val();
        cart.add(btn, ID, amount, mj, koef);         
    });
    
    // CART - QUANTITY CHANGE
    $(document).on("change", '.cart-item-quantity-set', function(e) {        
        e.preventDefault();
        
        var ID = $(this).data('product-id');
        var callback = $(this).data('callback');
        var amount = $(this).val();
        var mj = $(this).data('mj');
        var koef = $(this).data('koef');
        
        cart.set($(this), ID, amount, mj, koef, callback);         
    });
    
    // CART - remove
    $(document).on("click", '.cart-item-remove', function(e) {        
        e.preventDefault();
        
        var ID = $(this).data('product-id');
        var mj = $(this).data('mj');
        var callback = $(this).data('callback');
        cart.remove($(this), ID, mj, callback);
         
    });
    
    // DELIVERY ADDRES select
    $(document).on("change", 'input[name=delivery_address]', function(e) {        
        e.preventDefault();
        $(".shipping-address-box").removeClass("active");
        $(this).closest(".shipping-address-box").addClass("active");
    });
    
    // DELIVERY PERSON select
    $(document).on("change", 'input[name=delivery_person]', function(e) {        
        e.preventDefault();
        $(".shipping-person-box").removeClass("active");
        $(this).closest(".shipping-person-box").addClass("active");
    });
    
    // LOAD HEADER CART MINI
    $(".cart-dropdown").on("mouseenter", function (e) {
        if ($(".cart-dropdown").find('.dropdown-menu').length == 0) {
            cart.updateCartMini(e);
        } 
    });
    
    
    // CART - coupon add
    $(document).on("click", '.cart-coupon-add', function(e) {        
        e.preventDefault();        
        var coupon = $('#coupon').val();
        cart.coupon_add(coupon);
         
    });
    
    // CART - coupon remove
    $(document).on("click", '.cart-coupon-remove', function(e) {        
        e.preventDefault();
        cart.coupon_remove();
         
    });
    
    
    
})(jQuery);